import React, { useState } from "react";
import "../../components/DashboardModule/MyQuotations.css";
import "../../components/DashboardSeller/RASeller.css";
import BidModal from "./BidModal";

const RASeller = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleBidClick = () => {
    setIsModalOpen(true);
  };

  // Function to close the modal
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="quo-container font-poppins">
      <div className="quo-header">
        <h2 className="quo-title"></h2>
        <div className="quo-actions"></div>
      </div>

      <table className="quo-table">
        <thead>
          <tr>
            <th>Order Id</th>
            <th>Product Details</th>
            <th>Qty</th>
            <th>RA</th>
            <th>Value Added</th>
          </tr>
        </thead>
        {/* <tbody>
          <tr>
            <td>00123</td>
            <td>Fastgear 24 inch 15mm Steel Black Wire Plumbing Connection</td>
            <td>
              <ul>
                <li>Qty (50 pc)</li>
              </ul>
            </td>
            <td>Will be conveyed shortly</td>
            <td>Rs6,00,000</td>
            <td></td>
          </tr>
          <tr>
            <td>00123</td>
            <td>Fastgear 24 inch 15mm Steel Black Wire Plumbing Connection</td>
            <td>
              <ul>
                <li>Qty (50 pc)</li>
              </ul>
            </td>
            <td>Will be conveyed shortly</td>
            <td>Rs6,00,000</td>
            <td></td>
          </tr>
          <tr>
            <td>00123</td>
            <td>Fastgear 24 inch 15mm Steel Black Wire Plumbing Connection</td>
            <td>
              <ul>
                <li>Qty (50 pc)</li>
              </ul>
            </td>
            <td>
            
              <button className="bid-button" onClick={handleBidClick}>
                Bid
              </button>
            </td>
            <td>Rs6,00,000</td>
            <td></td>
          </tr>
        </tbody> */}
      </table>

      {/* Conditionally render the BidModal */}
      {isModalOpen && <BidModal onClose={handleCloseModal} />}
    </div>
  );
};

export default RASeller;
